// As we agreed we are creating our FE ideal interfaces. Feel free to extend this with Optional
// parameters that you neeed

export interface Pod {
  id: number;
  name: string;
  code: string;
}
